import { EmptyState, buttonClasses } from '@nexo/ui';
import { TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router';

/** Shown instead of a blank page when a screen crashes. */
export function RouteError() {
  const { t } = useTranslation();
  const error = useRouteError();
  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : null;
  return (
    <div className="flex h-full items-center justify-center bg-canvas p-6">
      <div className="max-w-md rounded-2xl border border-border bg-surface p-2 shadow-panel">
        <EmptyState
          icon={<TriangleAlert className="size-8 text-warning" />}
          title={t('Algo ha fallado')}
          description={t(
            'Ha ocurrido un error inesperado en esta pantalla. Recarga para volver a intentarlo.',
          )}
          action={
            <button
              type="button"
              onClick={() => window.location.reload()}
              className={buttonClasses()}
            >
              {t('Recargar')}
            </button>
          }
        />
        {detail && import.meta.env.DEV && (
          <pre className="mx-4 mb-4 overflow-auto rounded-lg bg-surface-2 p-3 text-xs text-muted">
            {detail}
          </pre>
        )}
      </div>
    </div>
  );
}
